export default "__VITE_ASSET__iXcRIQeT__"